import payApi from '@/api/pay'

export default {
    namespaced: true,
    state: {
        companyPay: {},
        billList: [],
        billDetailList: [],
        billAddonList: [],
        curBill: null,
    },
    getters: {
        getCompanyPay(state) {
            return state.companyPay
        },
        getBillList(state) {
            return state.billList
        },
        getBillDetailList(state) {
            return state.billDetailList
        },
        getBillAddonList(state) {
            return state.billAddonList
        },
        getCurBill(state) {
            return state.curBill
        }
    },
    actions: {
        getCompanyPay({state, commit}, payload) {
            payApi.getCompanyPay({}, (companyPay, billList, va) => {
                commit('setCompanyPay', companyPay)
                commit('setBillList', billList)

                if (payload.scb) {
                    payload.scb(companyPay, billList, va)
                }
            }, (err, va) => {
                if (payload.fcb) {
                    payload.fcb(err, va)
                }
            }, payload.va)
        },
        getBillDetailList({state, commit}, payload) {
            payApi.getBillDetailList({
                bill_seqno: payload.bill_seqno
            }, (billDetailList, billAddonList, va) => {
                commit('setBillDetailList', billDetailList)
                commit('setBillAddonList', billAddonList)
                if (payload.scb) {
                    payload.scb(va)
                }
            }, err => {
                if (payload.fcb) {
                    payload.fcb(err)
                }
            }, payload.va)
        }
    },
    mutations: {
        setCompanyPay(state, c) {
            if (!c) {
                return
            }

            state.companyPay = Object.assign({}, c)
        },
        setBillList(state, c) {
            state.billList.splice(0, state.billList.length)
            if (c) {
                c.forEach(item => {
                    state.billList.push(item)
                })
            }
        },
        setBillDetailList(state, c) {
            state.billDetailList.splice(0, state.billDetailList.length)
            if (c) {
                c.forEach(item => {
                    state.billDetailList.push(item)
                })
            }
        },
        setBillAddonList(state, c) {
            state.billAddonList.splice(0, state.billAddonList.length)
            if (c) {
                c.forEach(item => {
                    state.billAddonList.push(item)
                })
            }
        },
        setCurBill(state, c) {
            state.curBill = Object.assign([], c)
        }
    }
}